const LoadingOverlay = () => {
    return (
      <div 
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999
        }}
      >
        <div 
          style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #ff9100',
            borderRadius: '50%',
            width: '80px',
            height: '80px',
            animation: 'spin 1s linear infinite'
          }}
        />
      </div>
    );
  };
  
  export default LoadingOverlay;